<template>
	<div>
		<div class="headView">
			<p class="applyTitle">项目名称：2022年度北京市建筑业联合会优秀项目经理</p>
			<div class="headClass">
				<p>项目类型：优秀项目经理</p>
				<p>申请时间：2022.1.1-2022.1-15</p>
				<p>审核时间：2022.1.16-2022.1-30</p>
			</div>
		</div>
		<!-- 申报审核通用封装组件 -->
		<div class="content_view">
			<div class="contentLeft">
				<p v-for="(item,index) in navList" :key="index" @click="navIndex = index"
					:class="navIndex === index?'tabActive':''">
					{{item}}
				</p>
			</div>
			<div class="contentRight">
				<p v-if="navIndex == 0" class="view_head">申报通知</p>
				<p v-if="navIndex == 1" class="view_head">评选标准</p>
				<div v-if="navIndex == 2">
					<p class="view_head">
						基本信息
					</p>
					<div class="inputList">
						<labelInput :spanRequired="true" spanTitle="姓名" :spanWidth="spanWidth" componentWidth="520px">
						</labelInput>
						<labelInput :spanRequired="true" spanTitle="身份证号码" :spanWidth="spanWidth"
							componentWidth="520px"></labelInput>
						<labelInput :spanRequired="true" spanTitle="出生年月" :spanWidth="spanWidth" componentWidth="520px">
						</labelInput>
						<labelInput :spanRequired="true" spanTitle="学历" :spanWidth="spanWidth" componentWidth="520px">
						</labelInput>

						<labelInput :spanRequired="true" spanTitle="参加工作时间" :spanWidth="spanWidth"
							componentWidth="520px"></labelInput>

						<labelInput :spanRequired="true"  spanTitle="职称" :spanWidth="spanWidth" componentWidth="520px">
						</labelInput>

						<labelInput :spanRequired="true" spanTitle="建造师专业" :spanWidth="spanWidth"
							componentWidth="520px"></labelInput>

						<labelInput :spanRequired="true" spanTitle="建造师等级" :spanWidth="spanWidth"
							componentWidth="520px"></labelInput>
						<labelInput :spanRequired="true" spanTitle="注册编号" normalPlace="" :spanWidth="spanWidth"
							componentWidth="240px"></labelInput>
						<div class="specialView">
							<p style="color:#DBDBDB;">—</p>
							<input placeholder="第一个空格,控制为汉字,后面的控制为数字,数字要么12位,要么16位" />
						</div>
						<labelInput :spanRequired="true" spanTitle="获奖工程所从事职务" :spanWidth="spanWidth" componentWidth="520px">
						</labelInput>
						<labelInput :spanRequired="true" spanTitle="本人联系电话" :spanWidth="spanWidth"
							componentWidth="520px"></labelInput>
						<labelInput :spanRequired="true" spanTitle="单位主管部门" :spanWidth="spanWidth"
							componentWidth="520px"></labelInput>
						<div class="" style="width: 520px;">

						</div>
						<labelInput :spanRequired="true" spanTitle="单位联系" :spanWidth="spanWidth" componentWidth="520px">
						</labelInput>
						<labelInput :spanRequired="true" spanTitle="联系电话" :spanWidth="spanWidth" componentWidth="520px">
						</labelInput>
						<labelInput :spanRequired="true" spanTitle="最近一次继续教育年度" :spanWidth="spanWidth"
							componentWidth="520px"></labelInput>
						<div class="" style="width: 520px;">

						</div>
					</div>
				</div>
				<div class="" v-if="navIndex == 3">
					<p class="view_head">获奖信息</p>
					<div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
						<p class="view_head titleLeft">质量获奖情况</p>
						<div class="inputList">
							<labelInput :spanRequired="true" spanTitle="工程名称" :spanWidth="spanWidth" componentWidth="1060px">
							</labelInput>
							<labelInput :spanRequired="true" spanTitle="获奖名称" :spanWidth="spanWidth" componentWidth="520px">
							</labelInput>
							<labelInput :spanRequired="true" spanTitle="获奖时间" :spanWidth="spanWidth" componentWidth="520px">
							</labelInput>
							<div class="" style="margin-top: 50px;border-bottom: 1px solid #DBDBDB;margin-left: 120px;">
								
							</div>
						</div>
						<p class="view_head titleLeft">安全文明情况</p>
						<div class="inputList">
							<labelInput :spanRequired="true" spanTitle="工程名称" :spanWidth="spanWidth" componentWidth="1060px">
							</labelInput>
							<labelInput :spanRequired="true" spanTitle="获奖名称" :spanWidth="spanWidth" componentWidth="520px">
							</labelInput>
							<labelInput :spanRequired="true" spanTitle="获奖时间" :spanWidth="spanWidth" componentWidth="520px">
							</labelInput>
						</div>
					</div>
				</div>
				<div class="" v-if="navIndex == 4">
					<!--<div class="uploadHead">
						<img src="../../assets/img/main/muban.png" style="width: 20px;height: 20px;" >
						<p>模板下载</p>
					</div>-->
					<p class="view_head">资料上传</p>
					<div class="uploadList">
						<div class="uploadList_head">
							<p>一、北京市建筑企业优秀项目经理申请表</p>
							<div class="head_list">
								<img src="../../assets/img/banner/userlogin.png" style="width: 20px;height: 20px;" >
								<p>点击上传</p>
							</div>
						</div>
						<div class="uploadList_bot">
							<p>32442.jpg</p><p>dafds.jpg</p><p>dafdss.jpg</p>
						</div>
					</div>
					<div class="uploadList">
						<div class="uploadList_head">
							<p>二、建造师注册证书扫描件</p>
							<div class="head_list">
								<img src="../../assets/img/banner/userlogin.png" style="width: 20px;height: 20px;" >
								<p>点击上传</p>
							</div>
						</div>
						<div class="uploadList_bot">
							
						</div>
					</div>
					<div class="uploadList">
						<div class="uploadList_head">
							<p>三、项目经理身份证（正、反面）扫描件</p>
							<div class="head_list">
								<img src="../../assets/img/banner/userlogin.png" style="width: 20px;height: 20px;" >
								<p>点击上传</p>
							</div>
						</div>
						<div class="uploadList_bot">
							<p>32442.jpg</p><p>dafds.jpg</p><p>dafdss.jpg</p><p>32442.jpg</p><p>dafds.jpg</p><p>dafdss.jpg</p><p>32442.jpg</p><p>dafds.jpg</p><p>dafdss.jpg</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="content_btn" v-if="navIndex == 2">
			<p>一旦提交，不可修改，请谨慎操作</p>
			<el-button type="primary">确认提交</el-button>
		</div>
		<div class="uploadBtn" v-if="navIndex == 3">
			<el-button >返回</el-button>
			<el-button type="primary">保存</el-button>
		</div>
	</div>
</template>

<script>
	import labelInput from '../../components/table/labelInput.vue'
	export default {
		data() {
			return {
				navIndex: 0,
				spanWidth: '180px',
				navList: ["申报通知",
					"评选标准",
					"基本信息",
					"获奖信息",
					"资料上传"
				]
			}
		},
		components: {
			labelInput,
		},
		created() {
			console.log(this.$route.path)
		},
		methods: {

		}
	}
</script>

<style scoped>
	.uploadBtn{
		margin-top: 60px;
		margin-bottom: 60px;
		display: flex;
		margin-left: 560px;
	}
	.uploadBtn button{
		width: 140px;
	}
	/* 上传样式 */
	.uploadHead{
		display: flex;
		position: absolute;
		align-items: center;
		left: 255px;
	}
	.uploadHead p{
		margin-left: 10px;
		color: #1890FF;
		cursor: pointer;
	}
	.uploadList{
		border: 1px solid #f0f0f0;
		width: 90%;
		margin-top: 30px;
		margin-left: 5%;
	}
	.uploadList_head{
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 40px;
		padding: 0 40px 0 10px;
		line-height: 40px;
		font-size: 14px;
		border-bottom: 1px solid #f0f0f0;
	}
	.head_list{
		display: flex;
		align-items: center;
		cursor: pointer;
	}
	.head_list p{
		margin-left: 10px;
	}
	.head_list p:hover{
		color: #1890FF;
		text-decoration: underline;
	}
	.uploadList_bot{
		width: 70%;
		min-height: 30px;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: space-around;
		justify-content: flex-start;
	}
	.uploadList_bot p{
		display: inline-block;
		height: 40px;
		line-height: 40px;
		color: #1890FF;
		text-decoration: underline;
		margin: 0 20px;
		cursor: pointer;
	}
	/* 上传样式 */
	.inputList{
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}
	.titleLeft{
		margin-left: 50px;
	}
	.view_head {
		font-size: 18px;
		font-weight: 600;
		margin-top: 20px;
	}

	.headView {
		display: flex;
		flex-flow: column;
		align-items: flex-start;
	}

	.applyTitle {
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 600;
		color: #000000;
	}

	.headClass {
		display: flex;
		margin-top: 10px;
	}

	.headClass p {
		margin-right: 40px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
	}

	/* 申报 */
	.content_view {
		margin-top: 20px;
		width: 1350px;
		min-height: 350px;
		display: flex;
		border: 1px solid #f0f0f0;
	}

	.contentLeft {
		width: 200px;
	}

	.contentLeft p {
		height: 50px;
		line-height: 50px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		color: #333333;
		background-color: #fafafa;
		cursor: pointer;
	}

	.contentRight {
		width: 100%;
	}

	.tabActive {
		background: #e6f7ff !important;
		color: #6ea7ff !important;
		border-right: 2px solid #0077ff;
	}

	.content_btn {
		display: flex;
		flex-flow: column;
		align-items: flex-start;
		margin-top: 20px;
		margin-left: 180px;
	}

	.content_btn p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FE2C54;
	}

	.content_btn button {
		width: 150px;
		margin-top: 40px;
		margin-left: 440px;
	}

	.specialView {
		width: 720px;
		display: flex;
		align-items: center;
	}

	.specialView input {
		margin-left: 20px;
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		letter-spacing: 1px;
		border-bottom: 1px solid #DBDBDB;
	}

	.specialView input::placeholder {
		color: #B5B5B5;
	}
</style>
